import { Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useIntl } from 'react-intl';
import Config from '../../config/Config';
import '../../css/DppForm.css';

// Validation schema
const schema = z.object({
  returnNumber: z
    .string()
    .min(1, { message: 'Return number is required' })
    .trim(),
});

const ReturnNumberForm = ({
  showButtons = true,
  onSave,
  onCancel,
  isModal = false,
}) => {
  const intl = useIntl();
  const isDemo = Config.isDemo === 'true';
  const noAccessMessage = intl.formatMessage({ id: 'no_access_message', defaultMessage: 'Not authorized for this action' });
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid },
    reset,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      returnNumber: '',
    },
    mode: 'onTouched',
  });

  const handleCancel = () => {
    reset();
    onCancel?.();
  };

  const handleSave = (data) => {
    onSave?.(data);
    if (isModal) reset();
  };

  return (
    <Form onSubmit={handleSubmit(handleSave)} noValidate className="dpp-form">
      <Form.Group className="mb-4" controlId="returnNumber">
        <Form.Label>
          {intl.formatMessage({ id: 'return_number' })}
          <span className="text-red-600 ml-1" aria-hidden="true">*</span>
        </Form.Label>
        <Form.Control
          type="text"
          placeholder=""
          {...register('returnNumber')}
          isInvalid={!!errors.returnNumber}
          className="dpp-form-control"
        />
        <Form.Control.Feedback type="invalid">
          {errors.returnNumber?.message}
        </Form.Control.Feedback>
      </Form.Group>

      {/* Save / Cancel Buttons */}
      {showButtons && (
        <div className="d-flex justify-content-end gap-2">
          <Button
            variant="outline-secondary"
            onClick={handleCancel}
            className="dpp-modal-button"
          >
            {intl.formatMessage({ id: 'cancel' })}
          </Button>
          {isDemo ? (
            <OverlayTrigger
              placement="auto"
              overlay={<Tooltip id="save-tooltip">{noAccessMessage}</Tooltip>}
            >
              <span className="d-inline-block">
                <Button
                  variant="primary"
                  type="submit"
                  disabled
                  className="dpp-modal-button"
                  style={{ pointerEvents: 'none' }}
                >
                  {intl.formatMessage({ id: 'save' })}
                </Button>
              </span>
            </OverlayTrigger>
          ) : (
            <Button
              variant="primary"
              type="submit"
              disabled={!isDirty || !isValid}
              className="dpp-modal-button"
            >
              {intl.formatMessage({ id: 'save' })}
            </Button>
          )}
        </div>
      )}
    </Form>
  );
};

export default ReturnNumberForm;